var _defineProperty = require("/home/runner/work/web-blog/web-blog/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var $jEEMa$cryptojs = require("crypto-js");
var $jEEMa$jscookie = require("js-cookie");
var $jEEMa$axios = require("axios");
var $jEEMa$datefns = require("date-fns");
var $jEEMa$react = require("react");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "trackBuySubscriptionCta", () => $733dad7e5a9bbd1b$export$a31d5fdace682494);
$parcel$export(module.exports, "usePageImpressionTracking", () => $91d4ed07e483c904$export$cfcb51365b342240);
$parcel$export(module.exports, "inhouseTracking", () => $7d46ff84c7c02021$export$5d093d4672f77975);
$parcel$export(module.exports, "sendTrackingData", () => $7ebd42ddf9a12c1a$export$3c256a49c2fdbf43);
const $7d46ff84c7c02021$var$DEFAULTS = Object.freeze({
  TRACKING_API_URL: 'http://localhost:9292',
  IN_HOUSE_TRACKING_SALT: '',
  IN_HOUSE_TRACKING_SECRET: '',
  APP_TYPE: ''
});
const $7d46ff84c7c02021$export$5d093d4672f77975 = {
  config: _objectSpread({}, $7d46ff84c7c02021$var$DEFAULTS),
  configure(options) {
    this.config = _objectSpread(_objectSpread({}, this.config), options);
  }
};

/* eslint-disable @typescript-eslint/no-use-before-define */ /* eslint no-underscore-dangle: off */

var $b6352079e81f46fb$export$30362d9336dd96d4 = /*#__PURE__*/function (LocaleLanguageKey) {
  LocaleLanguageKey["De"] = "de";
  LocaleLanguageKey["En"] = "en";
  LocaleLanguageKey["Es"] = "es";
  LocaleLanguageKey["Fr"] = "fr";
  LocaleLanguageKey["It"] = "it";
  LocaleLanguageKey["Pl"] = "pl";
  LocaleLanguageKey["Pt"] = "pt";
  LocaleLanguageKey["Tr"] = "tr";
  LocaleLanguageKey["Ru"] = "ru";
  LocaleLanguageKey["Ja"] = "ja";
  return LocaleLanguageKey;
}({});
var $b6352079e81f46fb$export$20e688bdd0f88e4e = /*#__PURE__*/function (AssessmentGoalsWeb) {
  AssessmentGoalsWeb["BuildMuscle"] = "build_muscle";
  AssessmentGoalsWeb["GeneralFitness"] = "general_fitness";
  AssessmentGoalsWeb["LoseWeight"] = "lose_weight";
  AssessmentGoalsWeb["EatBetter"] = "eat_better";
  AssessmentGoalsWeb["MentalStrength"] = "mental_strength";
  return AssessmentGoalsWeb;
}({});
var $b6352079e81f46fb$export$b049503766c15701 = /*#__PURE__*/function (FitnessLevel) {
  FitnessLevel[FitnessLevel["Level1"] = 5] = "Level1";
  FitnessLevel[FitnessLevel["Level2"] = 17] = "Level2";
  FitnessLevel[FitnessLevel["Level3"] = 37] = "Level3";
  FitnessLevel[FitnessLevel["Level4"] = 62] = "Level4";
  FitnessLevel[FitnessLevel["Level5"] = 82] = "Level5";
  FitnessLevel[FitnessLevel["Level6"] = 95] = "Level6";
  return FitnessLevel;
}({});
var $b6352079e81f46fb$export$d549c77c8a078892 = /*#__PURE__*/function (Gender) {
  Gender["Male"] = "male";
  Gender["Female"] = "female";
  Gender["Unisex"] = "unisex";
  Gender["Nonbinary"] = "nonbinary";
  return Gender;
}({});
var $b6352079e81f46fb$export$c4b59befd1e721b1 = /*#__PURE__*/function (Modalities) {
  Modalities["Bodyweight"] = "bodyweight";
  Modalities["Weights"] = "weights";
  Modalities["Running"] = "running";
  Modalities["Mind"] = "mind";
  Modalities["Nutrition"] = "nutrition";
  Modalities["Barbell"] = "barbell";
  Modalities["Kettlebell"] = "kettlebell";
  Modalities["Dumbbell"] = "dumbbell";
  return Modalities;
}({});
const $b6352079e81f46fb$var$firstUppercase = word => word && word.charAt(0).toUpperCase() + word.slice(1);
const $b6352079e81f46fb$export$72d485cca95ce2e2 = sentence => sentence.split('_').map((word, index) => {
  if (index === 0) return word.toLowerCase();
  return $b6352079e81f46fb$var$firstUppercase(word);
}).join('');
const $b6352079e81f46fb$export$3561b44d041d13c = str => str.replace(/[A-Z | 0-9]/g, letter => "_".concat(letter.toLowerCase()));
function $b6352079e81f46fb$export$518c838eefe744d(date) {
  const tzo = -date.getTimezoneOffset();
  const dif = tzo >= 0 ? '+' : '-';
  const pad = num => {
    const norm = Math.floor(Math.abs(num));
    return (norm < 10 ? '0' : '') + norm;
  };
  return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), "T").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds())).concat(dif).concat(pad(tzo / 60), ":").concat(pad(tzo % 60));
}
function $8700447e8d1503bd$var$url(path) {
  return "".concat((0, $7d46ff84c7c02021$export$5d093d4672f77975).config.TRACKING_API_URL).concat(path);
}
function $8700447e8d1503bd$export$7d6f1c8842f9f527(_ref) {
  let {
    method = 'GET',
    path = '/',
    headers = {
      Accept: 'application/json'
    },
    data = {},
    params = {},
    skipAuthentication = false,
    authToken: authToken
  } = _ref;
  const config = {
    method: method,
    headers: headers,
    data: data,
    params: params,
    url: $8700447e8d1503bd$var$url(path)
  };
  if (!skipAuthentication) {
    const idToken = authToken || (0, $parcel$interopDefault($jEEMa$jscookie)).get('auth_id_token');
    if (idToken) config.headers.Authorization = "Bearer ".concat(idToken);
  }
  return (0, $parcel$interopDefault($jEEMa$axios))(config);
}
const $8700447e8d1503bd$export$14c7075810821661 = data => Array.isArray(data) ? $8700447e8d1503bd$export$aad49ecbeec7bf3b(data) : $8700447e8d1503bd$export$6c8532f729162b65(data);
function $8700447e8d1503bd$export$aad49ecbeec7bf3b(data) {
  const result = [];
  data.forEach(v => {
    if (Array.isArray(v)) result.push($8700447e8d1503bd$export$aad49ecbeec7bf3b(v));else if (typeof v === 'object') result.push($8700447e8d1503bd$export$6c8532f729162b65(v));else result.push(v);
  });
  return result;
}
function $8700447e8d1503bd$export$6c8532f729162b65(data) {
  if (!data) return undefined;
  const result = {};
  Object.keys(data).forEach(_k => {
    const k = _k.startsWith('__') ? _k : (0, $b6352079e81f46fb$export$72d485cca95ce2e2)(_k);
    if (Array.isArray(data[_k])) result[k] = $8700447e8d1503bd$export$aad49ecbeec7bf3b(data[_k]);else if (!data[_k]) result[k] = data[_k];else if (typeof data[_k] === 'object') result[k] = $8700447e8d1503bd$export$6c8532f729162b65(data[_k]);else result[k] = data[_k];
  });
  return result;
}
function $8700447e8d1503bd$export$aa0fdf762914ef48(data) {
  if (typeof data === 'string' || typeof data === 'number') return data;
  return Object.keys(data).reduce((res, k) => {
    let value;
    if (Object.prototype.toString.call(data[k]) === '[object Date]') value = data[k];else if (Array.isArray(data[k])) value = data[k].map(a => $8700447e8d1503bd$export$aa0fdf762914ef48(a));else if (typeof data[k] === 'object' && data[k] !== null) value = $8700447e8d1503bd$export$aa0fdf762914ef48(data[k]);else value = data[k];
    return _objectSpread(_objectSpread({}, res), {}, {
      [(0, $b6352079e81f46fb$export$3561b44d041d13c)(k)]: value
    });
  }, {});
}
const $209c98cc0b30fd50$var$SESSION_COOKIE_NAME = 'freeletics_tracking_session_id';
class $209c98cc0b30fd50$export$1fb4852a55678982 {
  constructor(lastInteraction, sessionId) {
    this.lastInteraction = lastInteraction;
    this.sessionId = sessionId !== null && sessionId !== void 0 ? sessionId : lastInteraction.getTime();
  }
  isActive() {
    if (!this.lastInteraction) return false;
    const now = new Date();
    const thirtyMinutesAgo = (0, $jEEMa$datefns.subMinutes)(now, 30).getTime();
    return thirtyMinutesAgo < this.lastInteraction.getTime() && now.getTime() > this.lastInteraction.getTime();
  }
  extend() {
    this.lastInteraction = new Date();
  }
}
class $209c98cc0b30fd50$export$415798a788f40554 {
  static getNewSession(sessionId, lastInteraction) {
    return new $209c98cc0b30fd50$export$1fb4852a55678982(lastInteraction ? new Date(lastInteraction) : new Date(), sessionId);
  }
  static extendActiveSession(session) {
    session.extend();
    const {
      sessionId: sessionId,
      lastInteraction: lastInteraction
    } = session;
    (0, $parcel$interopDefault($jEEMa$jscookie)).set($209c98cc0b30fd50$var$SESSION_COOKIE_NAME, "".concat(sessionId, ".").concat(lastInteraction.getTime()));
  }
  static getActiveSession() {
    const sessionCookie = (0, $parcel$interopDefault($jEEMa$jscookie)).get($209c98cc0b30fd50$var$SESSION_COOKIE_NAME);
    let sessionCookieId;
    let sessionCookieLastInteraction;
    if (sessionCookie) {
      [sessionCookieId, sessionCookieLastInteraction] = sessionCookie.split('.');
      sessionCookieId = parseInt(sessionCookieId, 10);
      sessionCookieLastInteraction = parseInt(sessionCookieLastInteraction, 10);
    }
    if (sessionCookieId && sessionCookieLastInteraction && !Number.isNaN(sessionCookieId) && !Number.isNaN(sessionCookieLastInteraction)) {
      let session = this.getNewSession(sessionCookieId, sessionCookieLastInteraction);
      let created = false;
      if (session.isActive()) this.extendActiveSession(session);else {
        session = this.getNewSession();
        created = true;
      }
      return {
        session: session,
        created: created
      };
    }
    const session = this.getNewSession();
    const {
      sessionId: sessionId,
      lastInteraction: lastInteraction
    } = session;
    (0, $parcel$interopDefault($jEEMa$jscookie)).set($209c98cc0b30fd50$var$SESSION_COOKIE_NAME, "".concat(sessionId, ".").concat(lastInteraction.getTime()));
    return {
      session: session,
      created: true
    };
  }
}

/**
 * Logs errors on trackjs in production or the in console in other environments.
 */
function $1abedda1fbe65884$export$58da9968c3170cb1(error) {
  let meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (window.TrackJS) window.TrackJS.track({
    message: error,
    meta: meta
  });else
    // eslint-disable-next-line no-console
    console.error(error);
}
const $6fdf1576d3b22f96$var$browserClientMap = {
  windows: /(Windows)/,
  android: /Android/,
  openBSD: /OpenBSD/,
  sunOS: /SunOS/,
  chromeOS: /CrOS/,
  linux: /(Linux|X11(?!.*CrOS))/,
  ios: /(iPhone|iPad|iPod)/,
  macos: /Mac/,
  qnx: /QNX/,
  unix: /UNIX/,
  beos: /BeOS/,
  'os/': /OS\/2/,
  searchbot: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
};
const $6fdf1576d3b22f96$export$267ffb63f15578cb = userAgent => {
  let verOffset;
  let browser = 'unknown';
  let version = 'unknown';
  let nameOffset;
  let ix;
  // Opera
  if (userAgent.indexOf('Opera') !== -1) {
    verOffset = userAgent.indexOf('Opera');
    browser = 'Opera';
    version = userAgent.substring(verOffset + 6);
    if (userAgent.indexOf('Version') !== -1) {
      verOffset = userAgent.indexOf('Version');
      version = userAgent.substring(verOffset + 8);
    }
  }
  // Opera Next
  if (userAgent.indexOf('OPR') !== -1) {
    verOffset = userAgent.indexOf('OPR');
    browser = 'Opera';
    version = userAgent.substring(verOffset + 4);
  } else if (userAgent.indexOf('Edge') !== -1) {
    verOffset = userAgent.indexOf('Edge');
    browser = 'Microsoft Legacy Edge';
    version = userAgent.substring(verOffset + 5);
  } else if (userAgent.indexOf('Edg') !== -1) {
    verOffset = userAgent.indexOf('Edg');
    browser = 'Microsoft Edge';
    version = userAgent.substring(verOffset + 4);
  } else if (userAgent.indexOf('MSIE') !== -1) {
    verOffset = userAgent.indexOf('MSIE');
    browser = 'Microsoft Internet Explorer';
    version = userAgent.substring(verOffset + 5);
  } else if (userAgent.indexOf('Chrome') !== -1 || userAgent.indexOf('CriOS') !== -1) {
    verOffset = userAgent.indexOf('Chrome');
    browser = 'Chrome';
    version = userAgent.substring(verOffset + 7);
  } else if (userAgent.indexOf('Safari') !== -1) {
    verOffset = userAgent.indexOf('Safari');
    browser = 'Safari';
    version = userAgent.substring(verOffset + 7);
    if (userAgent.indexOf('Version') !== -1) {
      verOffset = userAgent.indexOf('Version');
      version = userAgent.substring(verOffset + 8);
    }
  } else if (userAgent.indexOf('Firefox') !== -1) {
    verOffset = userAgent.indexOf('Firefox');
    browser = 'Firefox';
    version = userAgent.substring(verOffset + 8);
  } else if (userAgent.indexOf('Trident/') !== -1) {
    browser = 'Microsoft Internet Explorer';
    version = userAgent.substring(userAgent.indexOf('rv:') + 3);
  } else if (userAgent.indexOf('FBAV') !== -1) {
    browser = 'Facebook App';
    version = userAgent.substring(userAgent.indexOf('FBAV/') + 3);
  } else if (userAgent.lastIndexOf(' ') + 1 < userAgent.lastIndexOf('/')) {
    nameOffset = userAgent.lastIndexOf(' ');
    verOffset = userAgent.lastIndexOf('/');
    browser = userAgent.substring(nameOffset, verOffset);
    version = userAgent.substring(verOffset + 1);
    if (browser.toLowerCase() === browser.toUpperCase()) browser = navigator.appName;
  }
  // trim the version string
  if (version.indexOf(';') !== -1) {
    ix = version.indexOf(';');
    version = version.substring(0, ix);
  }
  if (version.indexOf(' ') !== -1) {
    ix = version.indexOf(' ');
    version = version.substring(0, ix);
  }
  if (version.indexOf(')') !== -1) {
    ix = version.indexOf(')');
    version = version.substring(0, ix);
  }
  return {
    browser: browser,
    version: version
  };
};
const $6fdf1576d3b22f96$export$7104f20e76a48433 = userAgent => {
  const clientOs = Object.keys($6fdf1576d3b22f96$var$browserClientMap).find(clientName => $6fdf1576d3b22f96$var$browserClientMap[clientName].test(userAgent));
  return {
    os: clientOs || 'unknown'
  };
};
const $6fdf1576d3b22f96$export$2ac00d7098bf223 = os => os === 'android' || os === 'ios';
const $6fdf1576d3b22f96$export$83e4be2b29078e4b = () => {
  // Fall back to localstorage if cookie is not available. (Fix for Safari cookie issue.)
  // https://stackoverflow.com/questions/37087869/javascript-cookies-not-working-in-safari
  const browserId = (0, $parcel$interopDefault($jEEMa$jscookie)).get('CID_UUID') || localStorage.getItem('CID_UUID');
  if (!browserId) {
    (0, $1abedda1fbe65884$export$58da9968c3170cb1)("CID_UUID is ".concat(browserId));
    return '';
  }
  return browserId;
};
const $6fdf1576d3b22f96$export$5ffdd2a176f24b63 = () => {
  var _get;
  const transactionId = parseInt((_get = (0, $parcel$interopDefault($jEEMa$jscookie)).get('inhouse_tis')) !== null && _get !== void 0 ? _get : '0', 10);
  return transactionId;
};
const $6fdf1576d3b22f96$export$92f42ae64097c6a0 = () => {
  var _get2;
  const transactionId = parseInt((_get2 = (0, $parcel$interopDefault($jEEMa$jscookie)).get('inhouse_tie')) !== null && _get2 !== void 0 ? _get2 : '0', 10);
  return transactionId;
};
const $6fdf1576d3b22f96$export$20f2e872a574d556 = () => {
  const transactionName = (0, $parcel$interopDefault($jEEMa$jscookie)).get('inhouse_lname');
  return transactionName;
};
const $6fdf1576d3b22f96$export$c9a4c370b07cd965 = () => {
  const prevTransactionId = $6fdf1576d3b22f96$export$5ffdd2a176f24b63();
  (0, $parcel$interopDefault($jEEMa$jscookie)).set('inhouse_tis', (prevTransactionId + 1).toString());
};
const $6fdf1576d3b22f96$export$e73a092f330f2ee5 = () => {
  const prevTransactionId = $6fdf1576d3b22f96$export$92f42ae64097c6a0();
  (0, $parcel$interopDefault($jEEMa$jscookie)).set('inhouse_tie', (prevTransactionId + 1).toString());
};
const $6fdf1576d3b22f96$export$d56d150f683adad4 = transactionName => {
  (0, $parcel$interopDefault($jEEMa$jscookie)).set('inhouse_lname', transactionName);
};
function $6fdf1576d3b22f96$export$1e931cc59e624464() {
  try {
    (0, $parcel$interopDefault($jEEMa$jscookie)).set('cookieTest', '1');
    const cookiesEnabled = (0, $parcel$interopDefault($jEEMa$jscookie)).get('cookieTest') === '1';
    (0, $parcel$interopDefault($jEEMa$jscookie)).remove('cookieTest');
    return cookiesEnabled;
  } catch (_unused) {
    return false;
  }
}
function $6fdf1576d3b22f96$export$351d079307a2c84b(nativeAppFeatureFlags) {
  window.nativeAppFeatureFlags = {};
  Object.keys(nativeAppFeatureFlags).forEach(featureFlagKey => {
    window.nativeAppFeatureFlags[featureFlagKey] = Number(nativeAppFeatureFlags[featureFlagKey]);
  });
}
function $6fdf1576d3b22f96$export$135560580e6a7346(nativeDeviceInformation) {
  window.nativeDeviceInformation = {};
  Object.keys(nativeDeviceInformation).forEach(featureFlagKey => {
    window.nativeDeviceInformation[featureFlagKey] = nativeDeviceInformation[featureFlagKey];
  });
}
function $3cd9c158e3093580$export$d9c1e6700aefa528() {
  const {
    userAgent: userAgent
  } = navigator;
  const {
    browser: browser,
    version: version
  } = (0, $6fdf1576d3b22f96$export$267ffb63f15578cb)(userAgent);
  const {
    os: os
  } = (0, $6fdf1576d3b22f96$export$7104f20e76a48433)(userAgent);
  return {
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    browser: "".concat(browser, "-").concat(version),
    os: os,
    deviceType: (0, $6fdf1576d3b22f96$export$2ac00d7098bf223)(os) ? 'mobile' : 'desktop'
  };
}
var $7e63d794e0839f97$export$d45701eb47e8bc02 = /*#__PURE__*/function (ApiErrors) {
  ApiErrors["BODYWEIGHT_API"] = "Request to bodyweight-api failed";
  ApiErrors["MARKETING_API"] = "Request to marketing-api failed";
  ApiErrors["MESSAGING_API"] = "Request to messaging-api failed";
  ApiErrors["PAYMENT_API"] = "Request to payment-api failed";
  ApiErrors["SOCIAL_API"] = "Request to social-api failed";
  ApiErrors["USER_API"] = "Request to user-api failed";
  ApiErrors["TRACKING_API"] = "Request to tracking-api failed";
  ApiErrors["CONTENTSTACK"] = "Request to ContentStack failed";
  return ApiErrors;
}({});
const $7ebd42ddf9a12c1a$var$getLocaleFromPath = path => {
  const langInPathMatch = path.match(/^\/([a-z]{2})(?:\/|$)/);
  return langInPathMatch ? langInPathMatch[1] : 'en';
};
const $7ebd42ddf9a12c1a$export$88b897c9bb1594b5 = () => {
  var _get3;
  const {
    screenWidth: screenWidth,
    screenHeight: screenHeight,
    browser: browser,
    deviceType: deviceType,
    os: os
  } = (0, $3cd9c158e3093580$export$d9c1e6700aefa528)();
  return {
    platform_type: 'web',
    amplitude_session_id: (0, $209c98cc0b30fd50$export$415798a788f40554).getActiveSession().session.sessionId,
    local_fired_at: (0, $b6352079e81f46fb$export$518c838eefe744d)(new Date()),
    fired_at_utc: new Date().toISOString(),
    app_type: (0, $7d46ff84c7c02021$export$5d093d4672f77975).config.APP_TYPE,
    fl_user_id: (_get3 = (0, $parcel$interopDefault($jEEMa$jscookie)).get('auth_user_id')) !== null && _get3 !== void 0 ? _get3 : -1,
    browser_id: (0, $6fdf1576d3b22f96$export$83e4be2b29078e4b)(),
    browser_version: browser,
    web_os_type: os,
    screen_width: screenWidth,
    screen_height: screenHeight,
    device_type: deviceType,
    logged_in: !!(0, $parcel$interopDefault($jEEMa$jscookie)).get('auth_user_id'),
    website_language: $7ebd42ddf9a12c1a$var$getLocaleFromPath(window.location.pathname)
  };
};
const $7ebd42ddf9a12c1a$export$fe1be8edea103a0b = body => {
  var _config$IN_HOUSE_TRAC, _config$IN_HOUSE_TRAC2;
  const unixTimestampInMillis = new Date().getTime();
  const salt = (_config$IN_HOUSE_TRAC = (0, $7d46ff84c7c02021$export$5d093d4672f77975).config.IN_HOUSE_TRACKING_SALT) !== null && _config$IN_HOUSE_TRAC !== void 0 ? _config$IN_HOUSE_TRAC : '';
  const secret = (_config$IN_HOUSE_TRAC2 = (0, $7d46ff84c7c02021$export$5d093d4672f77975).config.IN_HOUSE_TRACKING_SECRET) !== null && _config$IN_HOUSE_TRAC2 !== void 0 ? _config$IN_HOUSE_TRAC2 : '';
  let signature = '';
  try {
    signature = (0, $parcel$interopDefault($jEEMa$cryptojs)).HmacSHA256("".concat(salt).concat(window.btoa(body)).concat(unixTimestampInMillis), secret).toString((0, $parcel$interopDefault($jEEMa$cryptojs)).enc.Base64);
  } catch (err) {
    throw new Error("Tracking signature creation failed with body ".concat(encodeURIComponent(body)));
  }
  return {
    signature: signature,
    timestamp: unixTimestampInMillis
  };
};
const $7ebd42ddf9a12c1a$export$3c256a49c2fdbf43 = _ref2 => {
  let {
    name: name,
    data: data
  } = _ref2;
  const isCookieEnabled = (0, $6fdf1576d3b22f96$export$1e931cc59e624464)();
  if (!isCookieEnabled) (0, $1abedda1fbe65884$export$58da9968c3170cb1)('Cookies have been disabled.');else {
    const globalTrackingProperties = $7ebd42ddf9a12c1a$export$88b897c9bb1594b5();
    const passedTrackingProperties = data !== null && data !== void 0 ? data : {};
    const trackingProperties = {
      events: [{
        name: name,
        properties: _objectSpread(_objectSpread({}, globalTrackingProperties), passedTrackingProperties),
        contexts: {}
      }]
    };
    const signature = $7ebd42ddf9a12c1a$export$fe1be8edea103a0b(JSON.stringify(trackingProperties));
    const prevTransactionIdStart = (0, $6fdf1576d3b22f96$export$5ffdd2a176f24b63)();
    const prevTransactionIdEnd = (0, $6fdf1576d3b22f96$export$92f42ae64097c6a0)();
    const prevTransactionName = (0, $6fdf1576d3b22f96$export$20f2e872a574d556)();
    if (name === prevTransactionName && prevTransactionIdStart !== prevTransactionIdEnd) {
      (0, $1abedda1fbe65884$export$58da9968c3170cb1)("Duplicate tracking event. Name: ".concat(name, ", Transaction ID: ").concat(prevTransactionIdStart));
      return;
    }
    (0, $6fdf1576d3b22f96$export$c9a4c370b07cd965)();
    (0, $6fdf1576d3b22f96$export$d56d150f683adad4)(name);
    setTimeout(() => {
      (0, $6fdf1576d3b22f96$export$e73a092f330f2ee5)();
    }, 20);
    return new Promise(resolve => {
      (0, $8700447e8d1503bd$export$7d6f1c8842f9f527)({
        method: 'POST',
        path: '/v1/web/events',
        data: trackingProperties,
        headers: {
          'Content-Type': 'application/json',
          'X-Authorization': signature.signature,
          'Timestamp': signature.timestamp
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        (0, $1abedda1fbe65884$export$58da9968c3170cb1)((0, $7e63d794e0839f97$export$d45701eb47e8bc02).TRACKING_API, {
          error: error
        });
      });
    });
  }
};
const $e1c27f748f0c2060$var$trackClick = _ref3 => {
  let {
    name: name,
    data = {}
  } = _ref3;
  return (0, $7ebd42ddf9a12c1a$export$3c256a49c2fdbf43)({
    name: name,
    data: data
  });
};
var $e1c27f748f0c2060$export$2e2bcd8739ae039 = $e1c27f748f0c2060$var$trackClick;
const $d870e690147e27c6$export$d9d74947b8a3a089 = () => {
  var _window;
  const {
    pathname: pathname
  } = (_window = window) === null || _window === void 0 ? void 0 : _window.location;
  const key = pathname ? pathname.split('/')[2] : '';
  return key || 'homepage';
};
const $d870e690147e27c6$export$2fceb257638a2893 = () => {
  const {
    pathname: pathname
  } = window.location;
  return pathname.replace(/^\/[a-z]{2}\//, '/');
};
function $d870e690147e27c6$export$1c0ded0566738aac(inputString) {
  if (!inputString) return '';
  let latin1Filtered = '';
  for (let i = 0; i < inputString.length; i += 1) {
    const charCode = inputString.charCodeAt(i);
    if (charCode <= 126) latin1Filtered += inputString[i];
  }
  return latin1Filtered;
}
const $733dad7e5a9bbd1b$export$a31d5fdace682494 = _ref4 => {
  let {
    location: location
  } = _ref4;
  return (0, $e1c27f748f0c2060$export$2e2bcd8739ae039)({
    name: 'web.buy_subscription_cta_clicked',
    data: {
      'event.url': window.location.pathname,
      'event.location': location,
      'event.page_category': (0, $d870e690147e27c6$export$d9d74947b8a3a089)()
    }
  });
};
const $91d4ed07e483c904$export$cfcb51365b342240 = url => {
  const isWebViewPath = window.location.pathname.includes('web-view');
  (0, $jEEMa$react.useEffect)(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlParamsObj = Array.from(urlParams.keys()).reduce((acc, val) => _objectSpread(_objectSpread({}, acc), {}, {
      [(0, $d870e690147e27c6$export$1c0ded0566738aac)(val.toLowerCase())]: (0, $d870e690147e27c6$export$1c0ded0566738aac)(urlParams.get(val))
    }), {});
    const getConvertFeatureFlags = () => Object.keys(window).filter(item => item.includes('FEATURE_PE')).reduce((acc, curr) => {
      acc[curr] = window[curr];
      return acc;
    }, {});
    return (0, $7ebd42ddf9a12c1a$export$3c256a49c2fdbf43)({
      name: "".concat(isWebViewPath ? 'app_web' : 'web', ".url_page_impression"),
      data: {
        'event.url': url,
        'event.feature_flags': getConvertFeatureFlags(),
        'event.query_parameters': urlParamsObj,
        'event.url_without_language': (0, $d870e690147e27c6$export$2fceb257638a2893)(),
        'event.page_category': (0, $d870e690147e27c6$export$d9d74947b8a3a089)()
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
};